import { render, staticRenderFns } from "./ConsumptionsEditPage.vue?vue&type=template&id=19c8ce3e&"
import script from "./ConsumptionsEditPage.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionsEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports